import { BYO_MARKETS_REQUEST, BYO_MARKETS_SUCCESS, BYO_MARKET_FETCHING_STARTED, BYO_MARKET_CATEGORIES_FILTER, BYO_MARKETS_STOP_UPDATE_EVENT_SUBSCRIPTION, BYO_MARKETS_START_UPDATE_EVENT_SUBSCRIPTION, BYO_MARKETS_CLEAR_ALL, BYO_MARKETS_UPDATES_SUCCESS, BYO_IMPACT_SUB_DATA_SUCCESS, BYO_MARKETS_START_IMPACT_SUB_SUBSCRIPTION, BYO_MARKETS_STOP_IMPACT_SUB_SUBSCRIPTION, BYO_MARKETS_IMPACT_SUB_CLEAR, } from '../constants';
export const getMarkets = (locale, eventId, useBYOFreedom) => ({
    type: BYO_MARKETS_REQUEST,
    payload: {
        locale,
        eventId,
        useBYOFreedom,
    },
});
export const stopEventUpdatesSubscription = () => ({
    type: BYO_MARKETS_STOP_UPDATE_EVENT_SUBSCRIPTION
});
export const startEventUpdatesSubscription = () => ({
    type: BYO_MARKETS_START_UPDATE_EVENT_SUBSCRIPTION
});
export const clearAllMarketsWatcher = () => ({
    type: BYO_MARKETS_CLEAR_ALL
});
export const marketFetchingStarted = () => ({
    type: BYO_MARKET_FETCHING_STARTED,
});
export const saveMarkets = (markets) => ({
    type: BYO_MARKETS_SUCCESS,
    payload: markets,
});
export const saveMarketsUpdates = (updates) => ({
    type: BYO_MARKETS_UPDATES_SUCCESS,
    payload: updates,
});
export const filterMarkets = (categoryNameFilter) => ({
    type: BYO_MARKET_CATEGORIES_FILTER,
    categoryNameFilter,
});
export const saveImpactSubData = (marketData) => ({
    type: BYO_IMPACT_SUB_DATA_SUCCESS,
    payload: marketData,
});
export const startImpactSubSubscription = () => ({
    type: BYO_MARKETS_START_IMPACT_SUB_SUBSCRIPTION
});
export const stopImpactSubSubscription = () => ({
    type: BYO_MARKETS_STOP_IMPACT_SUB_SUBSCRIPTION
});
export const clearImpactSubData = () => ({
    type: BYO_MARKETS_IMPACT_SUB_CLEAR
});
